<template>
	<div>
		<el-card shadow="never">
			<div v-loading="formLoading">
				<el-form size="small" label-suffix=":" label-position="right" label-width="150px" :model="formData">
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="车场名称">
								{{formData.parkName}}
							</el-form-item>
						</el-col>
						<el-col :span="rightSpan">
							<el-form-item label="车位号">
								{{formData.parkingLot}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="车牌">
								{{formData.plateNumber}}
							</el-form-item>
						</el-col>
						<el-col :span="rightSpan">
							<el-form-item label="有效期">
								{{formData.beginTime | dateFmt("YYYY-MM-DD")}}至{{formData.endTime | dateFmt("YYYY-MM-DD")}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="车主">
								{{formData.owner}}
							</el-form-item>
						</el-col>
						<el-col :span="rightSpan">
							<el-form-item label="手机号">
								{{formData.phoneNumber}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="房产信息">
								{{formData.roomInfo}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="证照" class="large" style="width: 80%;">
                                <span v-show="!formData.imagesList || formData.imagesList.length == 0">无</span>
								<el-image v-for="imgUrl in formData.imagesList" class="imageItem" :preview-src-list="[imgUrl]" :key="imgUrl" :src="imgUrl" referrerPolicy="no-referrer">
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                        无法加载
                                    </div>
                                </el-image>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="收费标准">
								{{formData.feeType}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="车辆状态">
								{{formData.carState | dictLabel(carState)}}
							</el-form-item>
						</el-col>
						<el-col :span="rightSpan">
							<el-form-item label="订单是否需要确认">
								{{formData.isNeedConfirm | dictLabel(needConfirm)}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="车辆审核状态">
								{{formData.auditResult | dictLabel(auditState)}}
							</el-form-item>
						</el-col>
						<el-col :span="rightSpan">
							<el-form-item label="审核人">
								{{formData.auditName}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="leftSpan">
							<el-form-item label="车辆审核备注">
								{{formData.auditRemark}}
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>

				<!-- <div class="record">
					<span>续费申请记录</span>
					<el-divider></el-divider>
					<el-table
						:data="renewalApplyTableData"
						row-key="id"
						border
						v-loading="renewalApplyTableLoading"
						:stripe="true"
					>
						<el-table-column align="center" width="60" type="index" show-overflow-tooltip label="序号"></el-table-column>
						<el-table-column align="center" width="180" prop="createDate" label="申请时间"></el-table-column>
						<el-table-column align="center" width="180" prop="payStatus" label="支付状态">
							<template slot-scope="scope">
								<span>{{ scope.row.payStatus | dictLabel(payStatus) }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" width="120" prop="num" label="缴费月数"></el-table-column>
						<el-table-column align="center" prop="payMemo" label="费用说明"></el-table-column>
						<el-table-column align="center" width="150" prop="payAmount" label="应缴费用（元）">
							<template slot-scope="scope">
								<span>{{ scope.row.payAmount | toYuan }}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div class="record">
					<span>车牌修改记录</span>
					<el-divider></el-divider>
					<el-table
						:data="modifyCarNoTableData"
						row-key="id"
						border
						v-loading="modifyCarNoTableLoading"
						:stripe="true"
					>
						<el-table-column align="center" width="60" type="index" show-overflow-tooltip label="序号"></el-table-column>
						<el-table-column align="center" width="180" prop="createDate" label="申请时间"></el-table-column>
						<el-table-column align="center" prop="carIdOld" label="旧车牌"></el-table-column>
						<el-table-column align="center" prop="carIdNew" label="新车牌"></el-table-column>
						<el-table-column align="center" prop="submitUserName" label="提交人"></el-table-column>
					</el-table>
				</div> -->
			</div>
			<div class="form-buttons-center">
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import dlgForm from "@/mixin/dlgForm";
import { ownerType, carState, auditState, payStatus, needConfirm } from "@/dict/carDict";
import { pick, omit, assign } from "lodash";
import { get } from "@/assets/common/request";
import moment from 'moment';
window.moment = moment;
export default {
	name: "Detail",
	mixins: [dlgForm],
	data() {
		return {
			leftSpan: 10,
			rightSpan: 14,
			ownerType,
			carState,
			auditState,
			payStatus,
            needConfirm,
			renewalApplyTableData: [],
			modifyCarNoTableData: [],
			renewalApplyTableLoading: false,
			modifyCarNoTableLoading: false,
		};
	},
	methods: {
		loadForm() {  
			const url = `/car/web/carManage/card/${this.formData.cardId}`;
            const loadPhotoUrl = `/car/web/carManage/photo/${this.formData.cardId}`;
            this.formLoading = true;
            Promise.all([get(url), get(loadPhotoUrl)]).then(resps => {
                if(resps[0] && resps[0].code == 200) {
                    this.formData = resps[0].data;
                }
                let imagesList = [];
                if(resps[1] && resps[1].code == 200) {
                    const data = resps[1].data;
                    if(data) {
                        if(data.photo) {
                            imagesList = data.photo.split(',').filter(e => e);
                        }
                    }
                }
                this.formData.imagesList = imagesList;
            }).finally(() => {
                this.formLoading = false;
            })
		},
		loadRenewalApplyTableData() {
			const url = "";
			const params = {};
			get(url, params).then((res) => {
				this.renewalApplyTableData = [];
			});
		},
		loadRenewalApplyTableData() {
			const url = "";
			const params = {};
			get(url, params).then((res) => {
				this.modifyCarNoTableData = [];
			});
		},
	},
	mounted() {
        this.loadForm();
		// this.loadRenewalApplyTableData();
		// this.loadModifyCarNoTableData();
	},
};
</script>
<style scoped>
.record {
    margin-top: 20px;
}
.imageItem {
    display: inherit;
    overflow: hidden;
    width: 150px;
    height: 150px;
    margin-right: 10px
}
</style>
